/* BBB scroll-snap gallery: arrows, thumbs, counter, keyboard, variant sync. No deps. */
(function(){
  function init(g){
    if(g.__bbb)return; g.__bbb=1; g.classList.add('is-js');
    var track=g.querySelector('[data-track]'), slides=[].slice.call(track.children), n=slides.length, cur=0;
    var thumbsWrap=g.nextElementSibling&&g.nextElementSibling.matches('[data-bbb-thumbs]')?g.nextElementSibling:null;
    var thumbs=thumbsWrap?[].slice.call(thumbsWrap.querySelectorAll('[data-thumb]')):[];
    var prev=g.querySelector('[data-prev]'), next=g.querySelector('[data-next]'), count=g.querySelector('[data-count]');
    function go(i,smooth){ i=Math.max(0,Math.min(n-1,i)); track.scrollTo({left:slides[i].offsetLeft-track.offsetLeft,behavior:smooth===false?'auto':'smooth'}); set(i); }
    function set(i){ if(i===cur&&g.__set)return; g.__set=1; cur=i;
      if(count)count.textContent=(i+1)+' / '+n;
      if(prev)prev.disabled=i===0; if(next)next.disabled=i===n-1;
      thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===i?'true':'false');});
      if(thumbs[i]&&thumbsWrap.scrollWidth>thumbsWrap.clientWidth){thumbsWrap.scrollTo({left:thumbs[i].offsetLeft-thumbsWrap.clientWidth/2+thumbs[i].offsetWidth/2,behavior:'smooth'});}
      g.dispatchEvent(new CustomEvent('bbb:gallery:change',{detail:{index:i}}));
    }
    set(0);
    if(prev)prev.addEventListener('click',function(){go(cur-1);});
    if(next)next.addEventListener('click',function(){go(cur+1);});
    thumbs.forEach(function(t){t.addEventListener('click',function(){go(+t.dataset.thumb);});});
    g.addEventListener('keydown',function(e){ if(e.key==='ArrowRight'){e.preventDefault();go(cur+1);} else if(e.key==='ArrowLeft'){e.preventDefault();go(cur-1);} });
    if('IntersectionObserver' in window){
      var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting&&e.intersectionRatio>=.6)set(+e.target.dataset.index); });},{root:track,threshold:[.6]});
      slides.forEach(function(s){io.observe(s);});
    }
    // variant -> media
    var map={}; try{map=JSON.parse((g.parentNode.querySelector('[data-bbb-variant-media]')||{}).textContent||'{}');}catch(e){}
    function syncVariant(){ var f=document.querySelector('form[action*="/cart/add"] [name=id]'); if(!f)return; var mid=map[f.value]; if(!mid)return;
      for(var k=0;k<n;k++){ if(+slides[k].dataset.mediaId===mid){go(k);break;} } }
    document.addEventListener('change',function(e){ if(e.target.closest&&e.target.closest('form[action*="/cart/add"]'))setTimeout(syncVariant,50); });
    window.BBBGallery={go:go,sync:syncVariant};
  }
  function run(){ document.querySelectorAll('[data-bbb-gallery]').forEach(init); }
  if(document.readyState!=='loading')run(); else document.addEventListener('DOMContentLoaded',run);
})();
